import React, { Component } from 'react';
import './Gallery.css';
import itemData from '../data/items.js';
import FlipMove from 'react-flip-move';
import GalleryControls from './GalleryControls';

class Gallery extends Component {
  filterField = React.createRef();

  state = {
    items: itemData,
    loading: true,
    sortingMethod: 'default',
    isFiltered: false,
    filterQuery: '',
    filteredItems: []
  };

  getColor = () => {
    const colors = ['#FD4A4C', '#2C9898', '#CB3B8C', '#2d2d2d', '#3BCA3B', '#2A323E', '#F6921E', '#444444', '#A935A4', '#8AE147'];
    return colors[Math.floor(Math.random() * colors.length)]
  }

  componentDidMount() {
    this.filterItems(this.props.query);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.query !== this.props.query) {
      this.filterItems(nextProps.query);
    }
  }

  filterItems = (query) => {
    this.setState({ loading: true });
    let newItems = query === 'all' ? itemData : itemData.filter(item => item.type === query);
    this.setState({ items: newItems, loading: false });
  }

  onChronologicalClick = () => {
    if (this.state.sortingMethod === 'oldest') {
      let items = this.state.items;
      items.sort(function (a, b) {
        var dateA = new Date(a.timestamp), dateB = new Date(b.timestamp);
        return dateA - dateB;
      });
      this.setState({
        items: items,
        sortingMethod: 'newest'
      })
    } else if (this.state.sortingMethod === 'newest') {
      let items = this.state.items;
      items.sort(function (a, b) {
        var dateA = new Date(a.timestamp), dateB = new Date(b.timestamp);
        return dateB - dateA;
      });
      this.setState({
        items: items,
        sortingMethod: 'oldest'
      })
    } else {
      let items = this.state.items;
      items.sort(function (a, b) {
        var dateA = new Date(a.timestamp), dateB = new Date(b.timestamp);
        return dateA - dateB;
      });
      this.setState({
        items: items,
        sortingMethod: 'newest'
      })
    }
  }

  onShuffleClick = () => {
    const shuffledItems = this.state.items.sort(() => Math.random() - 0.5);
    this.setState({
      sortingMethod: 'shuffle',
      items: shuffledItems
    });
  }

  onRotateClick = () => {
    const items = this.state.items.slice();
    items.unshift(items.pop())

    this.setState({
      sortingMethod: 'rotate',
      items
    });
  }

  keywordFilter = (e) => {
    const keywordQuery = e.target.value;
    const regex = new RegExp(keywordQuery, "i");
    const items = this.state.items;

    const filteredItems = items.filter(item => {
      return regex.test(item.description) || regex.test(item.title);
    });

    this.setState({ isFiltered: true, filterQuery: keywordQuery, filteredItems: [...new Set(filteredItems)] })
  }

  clearFilter = () => {
    const state = this.state;
    this.setState({ ...state, isFiltered: false, filterQuery: '' });
  }

  render() {
    const galleryData = this.state.isFiltered ? this.state.filteredItems : this.state.items;

    return (
      <div>
        {(this.state.loading) ?
          <div><p>Loading...</p><div className="loader"></div></div>
          :
          <div className="galleryContainer">
            <GalleryControls
              sortingMethod={this.state.sortingMethod}
              onChronologicalClick={this.onChronologicalClick}
              onRotateClick={this.onRotateClick}
              onShuffleClick={this.onShuffleClick}
              keywordFilter={this.keywordFilter}
              clearFilter={this.clearFilter}
              isFiltered={this.state.isFiltered}
              filterField={this.filterField}
              filterQuery={this.filterQuery} />
            <FlipMove
              className="gallery"
              appearAnimation='fade'
              leaveAnimation="fade"
              easing="ease-in-out"
            >{galleryData.map(item =>
              <div
                key={item.id}
                style={{ background: this.getColor() }}>
                <h2>{item.title}</h2>
                <hr />
                <p>{item.description}</p>
                <ul className="tags">
                  {item.tags.map((tag, i) => <li key={i}>{tag}</li>)}
                </ul>
                <p className="timestamp">Published {item.timestamp}</p>
                <a className="button" href={item.link}>Check it out!</a>
              </div>
            )}
            </FlipMove>
          </div>}
      </div>
    );
  }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/Components/Gallery.jsx